import * as Cache from '@/utils/tools/cache'

const state = () => ({
  cname: Cache.get('cname') ? Cache.get('cname') : '',
  language: Cache.get('language') ? Cache.get('language') : 'en',
})

const mutations = {
  SET_CNAME: (state, name) => {
    state.cname = name
    Cache.set('cname', name)
  },
  SET_LANGUAGE: (state, name) => {
    state.language = name
    Cache.set('language', name)
  }
}

const actions = {
  setCname({ commit }, name) {
    commit('SET_CNAME', name)
  },
  setLanguage({ commit }, name) {
    commit('SET_LANGUAGE', name)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
